import React from 'react';
import { Card, message, Row, Col, Select, Button, DatePicker, Modal } from 'antd';
import { Formik, Form, ErrorMessage } from 'formik';
import { inductionScheduleSchema } from '../../Register/schema';
import axios from '../../../util/Api';
import Item from '../../../components/Form/Item';
import { Link } from 'react-router-dom';

const { Option } = Select;
const InductionSchedule = ({ passport }) => {
  const showNotification = (url) => {
    Modal.success({
      title: "Jadwalkan Hasil Induksi",
      content: (
        <div>
          Silakan kirimkan notifikasi ke {passport.vendor.name} melalui Whatsapp.
        </div>
      ),
      okText: "Kirimkan Notifikasi",
      okCancel: true,
      onOk() {
        //redirect to wa.me, then reload the detail page
        window.open(url, '_blank');
        // if (window.reloadDetail) {
        //   window.reloadDetail();
        // }
      }
    });
  }

  return passport.actions.display_induction_schedule ? (
    <Formik
      initialValues={{
        level: undefined,
        induction_date: undefined,
        quality: undefined
      }}
      validationSchema={inductionScheduleSchema}
      onSubmit={values => {
        const url = `/passport/induction-schedule?id=${passport.id}`;
        axios.post(url, { ...values }).then(resp => {
          showNotification(resp.data.whatsapp.url);
          if (window.reloadDetail) {
            window.reloadDetail();
          }
        }).catch(err => {
          message.error("Gagal melakukan verifikasi");
        });
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Card className="gx-card" title="Jadwalkan Induksi">
              <Row>
                <Col span={12}>
                  <div className="gx-mb-2">Kategori Resiko Pekerjaan</div>
                  <Item inline={false} name="HSE" required>
                    <Select
                      name="level"
                      defaultValue={formik.values.level}
                      onChange={(value) => formik.setFieldValue("level", value)}
                      placeholder="Pilih level"
                    >
                      <Option value="1">1</Option>
                      <Option value="2">2</Option>
                      <Option value="3">3</Option>
                    </Select>
                    <ErrorMessage component="div" name="level" className="gx-mt-2 gx-text-red" />
                  </Item>
                  <Item inline={false} name="Tanggal Induksi" required>
                    <DatePicker
                      onChange={(value) => {
                        formik.setFieldValue("induction_date", value.format("YYYY-MM-DD"));
                      }}
                      // disabledDate={(current) => {
                      //   return current && current > moment().endOf('day')
                      // }}
                      style={{ width: "100%" }}
                    />
                    <ErrorMessage component="div" name="induction_date" className="gx-mt-2 gx-text-red" />
                  </Item>
                </Col>
                <Col span={12}>
                  <div className="gx-mb-2">Kualifikasi Personel</div>
                  <Item inline={false} name="Quality" required>
                    <Select
                      name="quality"
                      defaultValue={formik.values.quality}
                      onChange={(value) => formik.setFieldValue("quality", value)}
                      placeholder="Pilih kualitas"
                    >
                      <Option value="A">A</Option>
                      <Option value="B">B</Option>
                      <Option value="C">C</Option>
                      <Option value="X">X</Option>
                    </Select>
                    <ErrorMessage component="div" name="quality" className="gx-mt-2 gx-text-red" />
                  </Item>
                </Col>
              </Row>

              <div className="gx-mt-2 gx-text-right">
                <Link to="/passport" className="ant-btn ant-btn-secondary gx-mb-0">
                  Batal
                </Link>
                <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>
                  Simpan
                </Button>
              </div>
            </Card>
          </Form>
        );
      }}
    </Formik>
  ) : null;
}

export default InductionSchedule;